document.addEventListener("DOMContentLoaded", function() {
    var url = new URL(window.location.href);
    var searchParams = new URLSearchParams(url.search);
    if (searchParams.has('srsltid')) {
        searchParams.delete('srsltid');
        var newUrl = url.origin + url.pathname + (searchParams.toString() ? '?' + searchParams.toString() : '');
        window.history.replaceState(null, null, newUrl);
    }
});
